export default __webpack_public_path__ + "static/media/marvel-search.6a6a3274.png";